
export const StatusFaturasEnum = [
    {
        label: "Selecione uma taxa",
        value: null,
    },
    {
        label: "Aguardando pagamento",
        value: 'pendente',
    },
    {
        label: "Cancelado",
        value: 'cancelado',
    },
    {
        label: "Atrasado",
        value: 'atrasado',
    },
    {
        label: "Estornado",
        value: 'estornado',
    },
    {
        label: "Contestado",
        value: 'contestado'
    }


];

